import { SellerInfo } from 'components/sellers/SellerInfo/SellerInfo'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileInfo: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerInfo mode='edit' type='profile' sellerId={sellerId ?? ''} />
}
